module.exports = __webpack_public_path__ + "img/19.311219c6.png";